import { AlmeState } from "@alme/ui-web/wireup/AlmeState";
import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";

export default class nextitCustomIvaMutator{

    _settings: AlightCustomSettingsType;
    _store: Store<AlmeState> | undefined;

    constructor(settings: AlightCustomSettingsType){
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>){
        this._store = store;
    }

    getMutator(){
        return(parameters: any) => {
            
            let payloadBase;
            if(window.enableIVAasService)
            {
                if (window.sessionStorage?.ivaServiceJsonData) {
                    payloadBase = JSON.parse(window.sessionStorage?.ivaServiceJsonData);
                }
                else{
                    payloadBase = window.enableIVAasService();
                }
            }
            else
            {
            //@ts-ignore
            let windowBase = this._store.getState()[this._settings.stateLocations.Window.Base];
            payloadBase = windowBase[this._settings.stateLocations.Window.productPayload.Base];
            }
            //if payload exists in the state
            if(payloadBase && payloadBase.customIVA){
                //  if payload contains data for IVA customization
                if (payloadBase.customIVA.IVAName || payloadBase.customIVA.IVAAvatar){
                    let newName = payloadBase.customIVA.IVAName;
                    let newAvatar = payloadBase.customIVA.IVAAvatar;

                    //  if the iva name needs to be customized
                    //@ts-ignore
                    if (!this._settings.textConstants.payloadDefaultIvaValue.includes(newName) &&
                     newName !== ""){
                        this._settings.textConstants.bannerText = `${newName} |`;
                        this._settings.livechat.textConstants.chatBannerUserDisconnectedSecondary = newName;
                        this._settings.livechat.textConstants.chatBannerOperatorDisconnectedSecondary = newName;
                    }   //  end if name shouldn't be default

                }   //  end if payload contains data for IVA customization
            }   //  end if the payload exists
            return parameters;
        }   //  end getMutator

    }   //  end return(parameters)
}


// WEBPACK FOOTER //
// ./modules/custom-iva/custom-iva.ts